import React, { memo } from "react";

interface IProps {
  size?: number;
}

const RelatedIcon: React.FC<IProps> = memo(({ size = 17 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.13479 12.2425C6.75521 12.3646 6.35046 12.4306 5.9303 12.4306C3.75966 12.4306 2 10.6709 2 8.50025C2 6.3296 3.75966 4.56995 5.9303 4.56995C6.35046 4.56995 6.75521 4.63587 7.13479 4.75795C6.20814 5.73199 5.63939 7.0497 5.63939 8.50025C5.63939 9.9508 6.20814 11.2685 7.13479 12.2425ZM8.5 13.2853C7.73499 13.697 6.85993 13.9306 5.9303 13.9306C2.93123 13.9306 0.5 11.4993 0.5 8.50025C0.5 5.50118 2.93123 3.06995 5.9303 3.06995C6.85993 3.06995 7.73499 3.30354 8.5 3.71524C9.26501 3.30354 10.1401 3.06995 11.0697 3.06995C14.0688 3.06995 16.5 5.50118 16.5 8.50025C16.5 11.4993 14.0688 13.9306 11.0697 13.9306C10.1401 13.9306 9.26501 13.697 8.5 13.2853ZM9.86521 4.75795C10.2448 4.63588 10.6495 4.56995 11.0697 4.56995C13.2403 4.56995 15 6.3296 15 8.50025C15 10.6709 13.2403 12.4306 11.0697 12.4306C10.6495 12.4306 10.2448 12.3646 9.86521 12.2425C10.7919 11.2685 11.3606 9.9508 11.3606 8.50025C11.3606 7.0497 10.7919 5.73199 9.86521 4.75795ZM8.5 5.52629C9.33333 6.24698 9.86061 7.31204 9.86061 8.50025C9.86061 9.68846 9.33333 10.7535 8.5 11.4742C7.66667 10.7535 7.13939 9.68846 7.13939 8.50025C7.13939 7.31204 7.66667 6.24698 8.5 5.52629Z"
        fill="currentColor"
      />
    </svg>
  );
});
export { RelatedIcon };
